import { useEffect } from 'react';

const useLockBodyScroll = (isOpen = true) => {
  useEffect(() => {
    isOpen
      ? (document.body.style.overflow = 'hidden')
      : (document.body.style.overflow = 'visible');

    // Re-enable scrolling when component unmounts
    return () => {
      document.body.style.overflow = 'visible';
    };
  }, [isOpen]); // Empty array ensures effect is only run on mount and unmount
};

export default useLockBodyScroll;
